export const getMinDateFromToday = (min: number) => {
  const today = new Date();
  const minDate = today.setDate(today.getDate() + min);
  return new Date(minDate);
};

export function UtcToKst(value: Date): Date {
  const time = value.getTime();
  const KSTOffset = -(value.getTimezoneOffset() * 60 * 1000);
  return new Date(time + KSTOffset);
}
